import angular from 'angular';
import searcheableContactSelector from './searcheableContactSelector';
import './style.scss';

export default angular
  .module('components.searcheableContactSelector', [])
  .component('searcheableContactSelector', searcheableContactSelector).name;
